import React from 'react';

import success from '../assets/success.png';

export default () => {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}
    >
      <img style={{ width: 50, height: 50, marginRight: 15 }} src={success} alt="success" />
      <h3 style={{ color: '#57ffa2' }}>Paid Successfully!</h3>
    </div>
  );
};
